import {
  UNAPPROVED_SESSIONS,
  PAYWALL_ONHOLD_SESSIONS,
  PAYWALL_PROFILE_LOADED,
  PAYWALL_SESSION_FOUND,
  PAYWALL_USER_FOUND,
  PAYWALL_USER_TOGGLE_TESTER,
  PAYWALL_ERROR
} from 'actions/paywallActions';
import { LOGOUT } from 'actions/authActions';

const initialState = {
  onHoldSessions: {},
  unapprovedSessions: {},
  profiles: {},
  userFound: null,
  sessionFound: null,
  error: ''
};

export default function auth (state = initialState, action) {
  const { sessions } = action;
  switch (action.type) {
    case PAYWALL_USER_FOUND:
    return {
      ...state,
      userFound: action.user || null,
      sessionFound: null,
      error: ''
    };
  case PAYWALL_SESSION_FOUND: {
    const {session, user} = action;
    return {
      ...state,
      sessionFound: session && user ? {
        session,
        user
      } : null,
      userFound: null,
      error: ''
    };
  }
  case UNAPPROVED_SESSIONS:
    return {
      ...state,
      unapprovedSessions: sessions
    };
  case PAYWALL_ONHOLD_SESSIONS:
    return {
      ...state,
      onHoldSessions: sessions
    };
  case PAYWALL_PROFILE_LOADED: {
    const {profiles} = state;
    const {userId, profileData} = action;
    let userFound = null
    if (state.userFound && state.userFound.userId === userId) {
      userFound = {
        ...state.userFound,
        profile: {
          ...profileData
        }
      }
    }
    return {
      ...state,
      profiles: {
        ...profiles,
        [userId]: profileData
      },
      ...(userFound ? { userFound } : {})
    };
  }
  /*
  case PAYWALL_USER_DELETED: {
    const {profiles} = state;
    const {userId} = action;
    const {[userId]: profileRemoved, restOfProfiles} = profiles;
    return {
      ...state,
      profiles: restOfProfiles
    };
  }
  */
  case PAYWALL_USER_TOGGLE_TESTER: {
    const {userId, tester} = action;
    const {profiles, userFound} = state;
    const profileData = profiles[userId];
    return {
      ...state,
      userFound: userFound ? {...userFound, profile: {...userFound.profile, tester}} : null,
      profiles: {
        ...profiles,
        [userId]: {...profileData, tester}
      }
    };
  }
  case PAYWALL_ERROR: {
    const { message } = action
    return {
      ...state,
      error: message
    };
  }
  case LOGOUT:
    return { ...initialState };
  default:
    return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/paywallReducer.js